(function () {
  const SELECTOR = '[data-launch-offer]';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function readStoredDeadline(storageKey) {
    try {
      const rawValue = window.localStorage.getItem(storageKey);
      const deadline = Number(rawValue);
      return Number.isFinite(deadline) ? deadline : null;
    } catch (error) {
      return null;
    }
  }

  function storeDeadline(storageKey, deadline) {
    try {
      window.localStorage.setItem(storageKey, String(deadline));
    } catch (error) {
      // Ignore localStorage failures and keep the countdown in memory.
    }
  }

  function getDeadline(element) {
    const durationSeconds = Number(element.dataset.durationSeconds || 0);
    if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) {
      return null;
    }

    const durationMs = durationSeconds * 1000;
    const storageKey = element.dataset.storageKey || 'laube-launch-offer';
    const now = Date.now();
    let deadline = readStoredDeadline(storageKey);

    if (!Number.isFinite(deadline) || deadline <= now) {
      deadline = now + durationMs;
      storeDeadline(storageKey, deadline);
    }

    element.dataset.deadline = String(deadline);
    return deadline;
  }

  function setValue(element, unit, value) {
    const target = element.querySelector(`[data-launch-offer-value="${unit}"]`);
    if (target) {
      target.textContent = pad(value);
    }
  }

  function updateTimer(element) {
    const durationSeconds = Number(element.dataset.durationSeconds || 0);
    if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) {
      return;
    }

    const durationMs = durationSeconds * 1000;
    const storageKey = element.dataset.storageKey || 'laube-launch-offer';
    let deadline = Number(element.dataset.deadline || 0);

    if (!Number.isFinite(deadline) || deadline <= 0) {
      deadline = getDeadline(element);
    }

    let remainingMs = deadline - Date.now();

    if (remainingMs <= 0) {
      deadline = Date.now() + durationMs;
      element.dataset.deadline = String(deadline);
      storeDeadline(storageKey, deadline);
      remainingMs = durationMs;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    setValue(element, 'days', days);
    setValue(element, 'hours', hours);
    setValue(element, 'minutes', minutes);
    setValue(element, 'seconds', seconds);

    element.setAttribute(
      'aria-label',
      `Offre de lancement. ${days} jours, ${hours} heures, ${minutes} minutes et ${seconds} secondes restantes.`
    );
  }

  function initLaunchOffer(element) {
    if (element.dataset.launchOfferInitialized === 'true') {
      return;
    }

    const deadline = getDeadline(element);
    if (!deadline) {
      return;
    }

    updateTimer(element);

    const intervalId = window.setInterval(function () {
      if (!document.body.contains(element)) {
        window.clearInterval(intervalId);
        return;
      }

      updateTimer(element);
    }, 1000);

    element.dataset.launchOfferInitialized = 'true';
  }

  function initLaunchOffers(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(initLaunchOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initLaunchOffers(document);
    });
  } else {
    initLaunchOffers(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initLaunchOffers(event.target);
  });
})();
